import { EStorageType } from 'reactApp/modules/storage/storage.types';

export const storages = {
    [EStorageType.home]: {
        id: EStorageType.home,
        title: 'Все файлы',
        isReactPage: true,
        isAvailableOnMobile: true,
        isAvailableToAnonymous: false,
        isSearchAvailable: true,
        settings: {
            path_as_id: true,
            hierarchy: true,
            add: true,
            remove: true,
            sub_folders: true,
            publish_files: true,
            publish_folders: true,
            download: true,
            multiDownload: true,
            move: true,
            rename: true,
            cache: true,
            root: true,
            edit: true,
            revisions: true,
        },
    },
    [EStorageType.sharedLinks]: {
        id: EStorageType.sharedLinks,
        title: 'Вы поделились',
        isReactPage: true,
        isSearchAvailable: true,
        gaPage: 'shared-links',
        settings: {
            hierarchy: false,
            path_as_id: true,
            add: false,
            remove: false,
            sub_folders: false,
            publish_files: true,
            publish_folders: false,
            download: true,
            multiDownload: true,
            move: false,
            rename: false,
            cache: true,
            root: true,
            edit: false,
            revisions: false,
        },
    },
    [EStorageType.sharedAutodelete]: {
        id: EStorageType.sharedAutodelete,
        title: 'Автоудаляемые',
        isSearchAvailable: true,
        isReactPage: true,
        gaPage: 'shared-autodelete',
        settings: {
            hierarchy: false,
            path_as_id: true,
            add: false,
            remove: false,
            sub_folders: false,
            publish_files: false,
            publish_folders: true,
            download: true,
            multiDownload: true,
            move: false,
            rename: false,
            cache: false,
            root: true,
            edit: false,
            revisions: false,
        },
    },
    [EStorageType.sharedIncoming]: {
        id: EStorageType.sharedIncoming,
        title: 'С вами поделились',
        isReactPage: true,
        isSearchAvailable: true,
        gaPage: 'shared-incoming',
        settings: {
            hierarchy: false,
            path_as_id: false,
            add: false,
            remove: true,
            sub_folders: false,
            publish_files: true,
            publish_folders: false,
            download: true,
            multiDownload: true,
            move: false,
            rename: false,
            cache: false,
            root: true,
            edit: false,
            revisions: false,
        },
    },
    [EStorageType.public]: {
        id: EStorageType.public,
        title: 'Публичные',
        isAvailableToAnonymous: true,
        isAvailableOnMobile: true,
        settings: {
            path_as_id: false,
            hierarchy: true,
            add: true,
            remove: false,
            sub_folders: false,
            publish_files: false,
            publish_folders: false,
            download: true,
            multiDownload: true,
            move: false,
            rename: false,
            cache: true,
            root: false,
            edit: false,
            revisions: false,
        },
    },
    static: {
        id: 'static',
        settings: {},
    },
    [EStorageType.search]: {
        id: EStorageType.search,
        title: 'Результаты поиска',
        isReactPage: true,
        isSearchAvailable: true,
        isAvailableOnMobile: true,
        gaPage: 'search',
        settings: {
            remove: true,
            publish_files: true,
            publish_folders: true,
            download: true,
            move: true,
            rename: true,
            root: true,
            edit: true,
            path_as_id: true,
            folderNameLink: true,
        },
    },
    [EStorageType.office]: {
        id: EStorageType.office,
        title: 'Microsoft Office Online',
        settings: {
            path_as_id: true,
            hierarchy: false,
            add: false,
            remove: false,
            sub_folders: false,
            publish_files: true,
            publish_folders: false,
            download: true,
            multiDownload: false,
            move: false,
            rename: true,
            cache: false,
            root: false,
            edit: true,
            revisions: false,
        },
    },
    [EStorageType.r7]: {
        id: EStorageType.r7,
        title: 'R7 office',
        settings: {
            path_as_id: true,
            hierarchy: true,
            add: false,
            remove: false,
            sub_folders: true,
            publish_files: true,
            publish_folders: false,
            download: true,
            multiDownload: false,
            move: false,
            rename: true,
            cache: false,
            root: false,
            edit: true,
            revisions: false,
        },
    },
    [EStorageType.myoffice]: {
        id: EStorageType.myoffice,
        title: 'Мой офис',
        settings: {
            path_as_id: true,
            hierarchy: true,
            add: false,
            remove: false,
            sub_folders: true,
            publish_files: true,
            publish_folders: false,
            download: true,
            multiDownload: false,
            move: false,
            rename: true,
            cache: false,
            root: false,
            edit: true,
            revisions: false,
        },
    },
    [EStorageType.stock]: {
        id: EStorageType.stock,
        title: 'Почтовые вложения',
        isAvailableToAnonymous: true,
        isAvailableOnMobile: true,
        settings: {
            path_as_id: false,
            hierarchy: false,
            add: false,
            remove: false,
            sub_folders: false,
            share_files: false,
            share_folders: false,
            download: true,
            multiDownload: true,
            move: false,
            rename: false,
            cache: true,
            root: false,
            edit: false,
            revisions: false,
        },
    },
    [EStorageType.trashbin]: {
        id: EStorageType.trashbin,
        title: 'Корзина',
        isReactPage: true,
        isSearchAvailable: true,
        isAvailableOnMobile: true,
        isAvailableToAnonymous: false,
        gaPage: 'trashbin',
        settings: {
            path_as_id: false,
            hierarchy: false,
            add: false,
            remove: false,
            sub_folders: false,
            share_files: false,
            share_folders: false,
            download: false,
            multiDownload: false,
            move: false,
            rename: false,
            cache: true,
            root: true,
            edit: false,
            revisions: false,
        },
    },
    [EStorageType.attaches]: {
        id: EStorageType.attaches,
        title: 'Из почты',
        isAvailableOnMobile: true,
        isSearchAvailable: true,
        isReactPage: true,
        settings: {
            path_as_id: true,
            hierarchy: false,
            add: false,
            remove: false,
            sub_folders: true,
            share_files: false,
            share_folders: false,
            download: true,
            multiDownload: true,
            move: false,
            rename: false,
            cache: true,
            root: true,
            edit: false,
            revisions: false,
        },
    },
    [EStorageType.favorites]: {
        id: EStorageType.favorites,
        title: 'Избранные',
        isSearchAvailable: true,
        isReactPage: true,
        gaPage: 'favorites',
        settings: {
            path_as_id: true,
            hierarchy: false,
            add: true,
            remove: true,
            sub_folders: false,
            share_files: true,
            share_folders: false,
            publish_files: true,
            download: true,
            multiDownload: true,
            move: false,
            rename: false,
            cache: true,
            root: true,
            edit: false,
            revisions: false,
        },
    },
    [EStorageType.feed]: {
        id: EStorageType.feed,
        title: 'Последние файлы',
        isReactPage: true,
        isSearchAvailable: true,
        gaPage: 'feed',
        settings: {
            path_as_id: true,
            hierarchy: false,
            add: true,
            remove: true,
            sub_folders: false,
            share_files: true,
            share_folders: false,
            publish_files: true,
            download: true,
            multiDownload: true,
            move: false,
            rename: false,
            cache: true,
            root: true,
            edit: false,
            revisions: false,
        },
    },
    [EStorageType.recommend]: {
        id: EStorageType.recommend,
        title: 'VK рекомендует',
        isReactPage: true,
        gaPage: 'recommend',
        settings: {
            path_as_id: true,
            hierarchy: false,
            add: false,
            remove: false,
            sub_folders: false,
            share_files: false,
            share_folders: false,
            publish_files: false,
            download: true,
            multiDownload: true,
            move: false,
            rename: false,
            cache: true,
            root: true,
            edit: false,
            revisions: false,
        },
    },
    [EStorageType.start]: {
        id: EStorageType.start,
        title: 'Быстрый доступ',
        isReactPage: true,
        isSearchAvailable: true,
        gaPage: 'start',
        settings: {
            path_as_id: true,
            hierarchy: true,
            add: false,
            remove: false,
            sub_folders: true,
            publish_files: true,
            publish_folders: true,
            download: false,
            multiDownload: false,
            move: false,
            rename: false,
            cache: true,
            root: true,
            edit: false,
            revisions: true,
        },
    },
    [EStorageType.gallery]: {
        id: EStorageType.gallery,
        title: 'Галерея',
        isSearchAvailable: true,
        isAvailableOnMobile: true,
        isReactPage: true,
        gaPage: 'gallery',
        settings: {
            path_as_id: true,
            hierarchy: false,
            add: true,
            remove: true,
            sub_folders: false,
            publish_files: true,
            publish_folders: false,
            download: true,
            multiDownload: true,
            move: false,
            rename: false,
            cache: true,
            root: true,
            edit: false,
            revisions: true,
        },
    },
    [EStorageType.documents]: {
        id: EStorageType.documents,
        title: 'Личные документы',
        isSearchAvailable: true,
        isReactPage: true,
        gaPage: 'documents',
        settings: {
            path_as_id: true,
            hierarchy: true,
            add: false,
            remove: true,
            sub_folders: true,
            publish_files: true,
            publish_folders: false,
            download: true,
            multiDownload: true,
            move: true,
            rename: false,
            cache: true,
            root: true,
            edit: false,
            revisions: true,
        },
    },
    [EStorageType.albums]: {
        id: EStorageType.albums,
        title: 'Альбомы',
        isSearchAvailable: true,
        isReactPage: true,
        gaPage: 'albums',
        settings: {
            path_as_id: false,
            hierarchy: true,
            add: false,
            remove: true,
            sub_folders: false,
            publish_files: false,
            publish_folders: true,
            download: true,
            multiDownload: true,
            move: false,
            rename: false,
            cache: false,
            root: true,
            edit: false,
            revisions: false,
        },
    },
    [EStorageType.subscriptions]: {
        id: EStorageType.subscriptions,
        isAvailableOnMobile: true,
        isAvailableToAnonymous: true,
        isSearchAvailable: false,
        isReactPage: true,
        gaPage: 'subscriptions',
        settings: {},
    },
    [EStorageType.embedded]: {
        id: EStorageType.embedded,
        title: 'Встраиваемый просмотр внешних файлов',
        isAvailableOnMobile: true,
        isAvailableToAnonymous: true,
        isSearchAvailable: false,
        isReactPage: true,
        gaPage: 'embedded',
        settings: {},
    },
};
